import React from "react";
import { Header, Segment, List, Message } from "semantic-ui-react";

const DetailDocumentation = () => {
  return (
    <Segment padded>
      <Header as="h2" dividing>
        Record Detail API
      </Header>
      <Message info>
        <Message.Header>Overview</Message.Header>
        <p>
          The Record Detail API allows you to retrieve the details of a specific
          record in the system. You can access both published and draft records,
          depending on your permissions.
        </p>
      </Message>
      <Header as="h3">Types</Header>
      <Segment>
        <List bulleted>
          <List.Item>
            <strong>published</strong> - Access published records.
          </List.Item>
          <List.Item>
            <strong>draft</strong> - Requires permissions to read draft records.
          </List.Item>
        </List>
      </Segment>
      <Header as="h3">Published Detail Request</Header>
      <Message>
        <Message.Content>
          <strong>GET</strong> /api/&lt;model_name&gt;/&lt;record_id&gt;
        </Message.Content>
      </Message>
      <Header as="h3">Draft Detail Request</Header>
      <Message>
        <Message.Content>
          <strong>GET</strong> /api/&lt;model_name&gt;/&lt;record_id&gt;/draft{" "}
          <br />
          <strong>Headers:</strong> <br />
          Authorization: Bearer &lt;authToken&gt;
        </Message.Content>
      </Message>
    </Segment>
  );
};

export default DetailDocumentation;
